module.exports = __webpack_public_path__ + "static/media/instagram.0009fe9f.png";